export const isLargeComparisonGroup = (numFips: number) => numFips > 10;
